import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x-icon",
  "use": "x-icon-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"x-icon\"><path stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" d=\"M1 1l10 10M1 11L11 1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol